import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { smartDocParamType_Static, smartDocStaticParam_PartialData, smartDocStaticParamType_MDM, smartDocStaticParamTypeLabelMap, smartDocStaticParamTypes } from '@app/advisor-content-shared';
import { smartDocExternalParamType, smartDocExternalParamTypeLabelMap, smartDocParamType_External } from '@app/advisor-content-shared';
import { ImplementationMissingException } from '@nu-art/ts-common';
import { smartDocStaticParamType_SmartMDM } from '@app/advisor-content-shared';
export class DropDown_SmartDocParamSubType extends ComponentSync {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state.editable = nextProps.editable;
        return state;
    }
    // ######################## Logic ########################
    getAdapter = () => {
        const param = this.state.editable;
        let options;
        let labelMap;
        switch (param.item.type) {
            case smartDocParamType_Static:
                options = [...smartDocStaticParamTypes].filter(subType => this.props.allowedParamSubTypes[smartDocParamType_Static]?.includes(subType));
                labelMap = smartDocStaticParamTypeLabelMap;
                break;
            case smartDocParamType_External:
                options = [...smartDocExternalParamType].filter(subType => this.props.allowedParamSubTypes[smartDocParamType_External]?.includes(subType));
                labelMap = smartDocExternalParamTypeLabelMap;
                break;
            default:
                throw new ImplementationMissingException(`Missing sub types for param of type ${param.item.type}`);
        }
        return SimpleListAdapter(options, node => _jsx(_Fragment, { children: labelMap[node.item] }));
    };
    onSubTypeSelected = async (subType, prevType) => {
        const param = this.state.editable;
        let partialData = smartDocStaticParam_PartialData[subType] ?? {};
        if ([smartDocStaticParamType_SmartMDM, smartDocStaticParamType_MDM].includes(subType) && [smartDocStaticParamType_SmartMDM,
            smartDocStaticParamType_MDM].includes(prevType ?? '')) {
            const currentData = this.state.editable.item;
            partialData = {
                protocolType: currentData.protocolType,
                protocolConsiderationGroup: currentData.protocolConsiderationGroup,
                protocolStatus: currentData.protocolStatus,
                resolver: currentData.resolver,
            };
        }
        //Rewrite the item (clean all except the properties below)
        param.updateItem({
            // @ts-ignore
            key: param.item.key,
            // @ts-ignore
            type: param.item.type,
            // @ts-ignore
            subType: subType,
            ...(partialData),
        });
        return param.save();
    };
    // ######################## Render ########################
    render() {
        const param = this.state.editable;
        const adapter = this.getAdapter();
        return _jsx(TS_DropDown, { adapter: adapter, selected: param.item.subType, onSelected: type => this.onSubTypeSelected(type, param.item.subType) });
    }
}
//# sourceMappingURL=DropDown_SmartDocParamSubType.js.map